import "@/i18n/i18n-config.js";
import "./services/analytics/initAnalytics";

import React from "react";
import { createRoot } from "react-dom/client";
import HttpsRedirect from "react-https-redirect";
import posthog from "posthog-js";
import { PostHogErrorBoundary, PostHogProvider } from "@posthog/react";

import App from "@/app";
import ErrorPageRecovery from "@/pages/error-page-recovery/error-page-recovery";

const root = createRoot(document.getElementById("root"));
root.render(
    <PostHogProvider client={posthog}>
        <PostHogErrorBoundary fallback={ErrorPageRecovery}>
            <HttpsRedirect disabled={import.meta.env.VITE_ALLOWHTTP}>
                <App />
            </HttpsRedirect>
        </PostHogErrorBoundary>
    </PostHogProvider>,
);

// eslint-disable-next-line prefer-arrow-callback
navigator.serviceWorker.getRegistrations().then(function registerServiceWorker(registrations) {
    for (let i = 0; i < registrations.length; i++) {
        const registration = registrations[i];
        registration.unregister();
    }
});
